import { AuthorizationError, NotFoundError } from '@ametista-ai/api-schema/errors';
import * as Sentry from '@sentry/react';
import { config } from '../config';

const commitSha = import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA || '';

const ignoredErrorTypes = [
  AuthorizationError,
  // BadRequestError,
  // NetworkError,
  NotFoundError,
  // OfflineError,
  // PaymentRequiredError,
  // RateLimitExceededError,
  // ServiceUnavailableError,
  // UpdateRequiredError,
];

Sentry.init({
  dsn: config.sentry.dsn,

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.browserTracingIntegration(),
    // Sentry.feedbackIntegration({
    //   colorScheme: 'system',
    // }),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  enabled: import.meta.env.PROD ?? true,

  release: commitSha || undefined,

  // ignoreErrors: [
  //   "Failed to fetch dynamically imported module",
  //   "ResizeObserver loop completed with undelivered notifications",
  //   "ResizeObserver loop limit exceeded",
  //   "file://",
  //   "chrome-extension://",
  // ],

  beforeSend(event, hint) {
    const error = hint.originalException;
    if (error && ignoredErrorTypes.some((type) => error instanceof type)) {
      return null;
    }
    return event;
  },
});
